import { render, staticRenderFns } from "./SimpleUpload.vue?vue&type=template&id=015bc76b&"
import script from "./SimpleUpload.vue?vue&type=script&lang=js&"
export * from "./SimpleUpload.vue?vue&type=script&lang=js&"
import style0 from "./SimpleUpload.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports